import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { UploadIcon } from 'components';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: () => void;
};

const UploadButton = (props: Props) => {
  const { id, sx, children, onClick } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    onClick && onClick();
  };

  return (
    <Button
      id={id}
      sx={{
        width: '240px',
        height: '50px',
        mx: 'auto',
        my: 0,
        p: 1,
        textAlign: 'center',
        bgcolor: baseColors.red,
        borderRadius: '6px',
        boxShadow: 2,
        ...sx
      }}
      onClick={handleClick}
    >
      <Typography
        variant="subtitle1"
        sx={{
          display: 'flex',
          color: baseColors.white
        }}
      >
        <UploadIcon style={{ width: 18, marginTop: -3, marginRight: 6 }} />
        {children ? children : 'アップロードする'}
      </Typography>
    </Button>
  );
};

export default UploadButton;
